import React, { useState } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";
import Login from "../../pages/Login";
import Register from "../../pages/Register";

export const globalContext = React.createContext();

const Layout = () => {
  // const [loginModal, setloginModal] = useState(false);
  // const toggleLogin = () => setloginModal(!loginModal);

  // const [signUpModal, setSignUpModal] = useState(false);
  // const toggleRegister = () => setsignUpModal(!signUpModal);

  const [bookingModal, setBookingModal] = useState(false);
  const toggleBookingModal = () => setBookingModal(!bookingModal);

  return (
    <globalContext.Provider
      value={{
        // toggleLogin,
        // loginModal,
        // toggleRegister,
        // signUpModal,
        toggleBookingModal,
        bookingModal,
      }}
    >
      <>
        <Header />
        <Login />
        <Register />
        <div>
          <Routers />
        </div>
        <Footer />
      </>
    </globalContext.Provider>
  );
};

export default Layout;
